import moment from "moment";
import { ModalBody, ModalHeader, ModalPanel } from "../../components/Modal"
import { Button } from "../../components/Button"
import { RiMore2Fill } from "react-icons/ri"
import { Grid } from "../../components/Table";
import { RemoveAssistanceContainer } from "../../container/RemoveAssistanceContainer";
import { LatestAppointmentsExecuteContainer } from "../../container/LatestAppointmentsExecuteContainer";
import { PickerWithType } from "../../components/DatePicker";
import { Label, SelectInput } from "../../components/Form";
import { TabSelect } from "../../components/TabSelect";
import { TagsCellGrid } from "../../components/UserList";
import "./styles.scss"
import LastAppointmentsDetailsContainer from "../../container/LastestAppointmentsDetailsContainer";

const ProducerNameCell = ({ props, handleOpendDetails }) => {
  const newValue = typeof props?.textValue === 'string' ? props.textValue.split(',') : [];
  if(!newValue) return <></>;

  const newProducerList = newValue.slice(0, 4);

  return <div className='producer-name-cell' onClick={() => handleOpendDetails(props.data)}>
    {newProducerList.map(userName => (
      <small>{userName}</small>
    ))}
    {newValue && newValue.length > 4 ? <p>+{newValue.length - newProducerList.length}</p> : <></>}
  </div>
}

const CellAssistanceLink = ({ props }) => {
  const assistanceId = props.value ?? '';
  const link = `https://manejechat.com.br/assistance/${assistanceId}`;

  return (
    <div className="cell__container">
      <a target="_blank" href={link}>{link}</a>
    </div>
  )
}

const EventDateCell = ({ props, handleOpendDetails }) => {
  const date = props?.value ?? '';

  return <div className="cell__container" onClick={() => handleOpendDetails(props.data)}>
    {moment(date).format('DD/MM/YYYY') || 'Sem Data'}
  </div>
}

const SelectRowCell = ({ props, handleOpendDetails, }) => {
  const date = props?.value ?? '';
  return <div className="cell__container" onClick={() => handleOpendDetails(props.data)}>
    {date}
  </div>
}

const AssistanceListModal = ({
  isAssistanceModalOpen,
  handleCloseAssistanceModal,
  columnsModal,
  selectedAssistances
}) => {
  return (
    <ModalPanel modalIsOpen={isAssistanceModalOpen}>
      <ModalHeader title="Atendimentos do Evento" closeModal={handleCloseAssistanceModal} />
      <ModalBody>
        <div className="modal-buttons-group">
          <Grid
            columns={columnsModal}
            rows={selectedAssistances}
            selectedRowsIds={[]}
            onSelectedRowsChange={() => {}}
          />
        </div>
      </ModalBody>
    </ModalPanel>
  )
}

export const LatestAppointmentsScreen = ({
  data,
  handleEventStatus,
  modalActions,
  handleSelectedUsers,
  handleOpenActionsModal,
  handleCloseActionsModal,
  selectedUsers,
  handleCloseAssistanceModal,
  isAssistanceModalOpen,
  selectedRows,
  selectedAssistances,
  isUserAdmin,
  handleChangeCurrentTab,
  tab,
  tagsOptions,
  handleChangeFilter,
  handleRemoveTag,
  handleOpendDetails,
  openDetails,
  selectedEvent,
  goBack,
  filter
}) => {

  const executedColumns = [
    {
      id: "checkbox",
      name: "checkbox",
    },
    {
      id: "project",
      field: "project",
      label: "Projeto",
      width: "240px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "responsible",
      field: "responsible",
      label: "Quem criou",
      width: "240px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "technician",
      field: "technician",
      label: "Técnico(a)",
      width: "240px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "assistanceId",
      field: "assistanceId",
      label: "Atendimento",
      width: "240px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "producerName",
      field: "producerName",
      label: "Produtor",
      width: "260px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "tags",
      field: "tags",
      label: "Tags",
      width: "320px",
      cellRenderer: ({ row, data }) => (
        <div className="tags-assistance">
          <TagsCellGrid {...{ row, data }} handleRemoveTag={handleRemoveTag} />
        </div>
      ),
    },
    {
      id: "createdAt",
      field: "createdAt",
      label: "Data",
      width: "150px",
      cellRenderer: (props) => <EventDateCell {...{ props }} />,
    },
    {
      id: "description",
      field: "description",
      label: "Descrição",
      width: "260px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "eventId",
      field: "eventId",
      label: "Evento",
      width: "260px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
  ]

  const notExecutedColumns = [
    {
      id: "checkbox",
      name: "checkbox",
    },
    {
      id: "project",
      field: "project",
      label: "Projeto",
      width: "240px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "responsible",
      field: "responsible",
      label: "Quem criou",
      width: "140px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "technician",
      field: "technician",
      label: "Técnico",
      width: "140px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "dateToAdd",
      field: "createdAt",
      cellRenderer: (props) => (
        <EventDateCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
      label: "Execução",
      width: "150px",
    },
    {
      id: "tagsToAdd",
      field: "tagsToAdd",
      label: "Setor(es)",
      width: "200px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "userNames",
      field: "userNames",
      label: "Produtores",
      cellRenderer: (props) => <ProducerNameCell {...{ props }} handleOpendDetails={handleOpendDetails} />,
      width: "290px",
    },
    {
      id: "userIds",
      field: "userIds",
      label: "Qtd. de Produtores",
      width: "150px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "description",
      field: "description",
      label: "Descrição",
      width: "200px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "isFinished",
      field: "isFinished",
      label: "Status do Evento",
      width: "200px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
    {
      id: "uniqueAssistance",
      field: "uniqueAssistance",
      label: "Tipo de Atendimento",
      width: "200px",
      cellRenderer: (props) => (
        <SelectRowCell {...{ props }} handleOpendDetails={handleOpendDetails} />
      ),
    },
  ]

  const columnsModal = [
    {
      id: "assistanceId",
      field: "assistanceId",
      cellRenderer: (props) => <CellAssistanceLink {...{ props }} />,
      label: "Atendimento",
      width: "500px",
    },
    {
      id: "isFinished",
      field: "isFinished",
      label: "Status",
      width: "150px"
    },
  ]

  return (
    <div>
      <div className="button-action">
        <div  className="actions__left">
          <TabSelect
            options={[{ value: 'executed', label: 'Executados'}, { value: 'not_executed', label: 'Agendamentos'}]}
            getTab={(value) => handleChangeCurrentTab(value)}
          />
        </div>
        <div className="actions__right">
          {
            tab === 'executed' &&
            <Label label="Filtrar Tag(s)">
              <SelectInput
                isSearchable
                whiteVariation
                resetFields={!filter?.tags}
                placeholder='Selecionar tags'
                isMulti
                value={filter?.tags}
                options={tagsOptions || []}
                onChange={(value) => handleChangeFilter('tags', value)}
              />
            </Label>
          }
          <Label label="Data">
            <PickerWithType
              onChange={(value) => handleChangeFilter("date", value)}
              defaultValue={filter?.date}
            />
          </Label>
          <Button
            hiddenText
            hasIcon={<RiMore2Fill size={16} />}
            label="Ações"
            handleClick={handleOpenActionsModal}
            color="orange"
            className="dashboard"
            isDisabled={!selectedRows || !selectedRows.length}
            count={selectedRows.length || ""}
          />
        </div>
      </div>
      <div style={{ marginTop: "16px" }}>
        {
          tab === 'executed' ? 
          <>
          {openDetails ? <LastAppointmentsDetailsContainer {...{selectedEvent, goBack}}/> : <div className="lastest-appointments-grid-container">
          <Grid
            columns={executedColumns}
            rows={data}
            onSelectedRowsChange={handleSelectedUsers}
          />
          </div>}
          </> : 
          <div>
            {openDetails && !selectedEvent.assistanceId ? <LastAppointmentsDetailsContainer {...{selectedEvent, goBack}}/> : <div className="lastest-appointments-grid-container">
          <Grid
            columns={notExecutedColumns}
            rows={data}
            onSelectedRowsChange={handleSelectedUsers}
          />
          </div>}
          </div>
        }
      </div>
      <AssistanceListModal
        handleCloseAssistanceModal={handleCloseAssistanceModal}
        isAssistanceModalOpen={isAssistanceModalOpen}
        selectedUsers={selectedUsers}
        columnsModal={columnsModal}
        selectedAssistances={selectedAssistances}
      />
      <ModalPanel modalIsOpen={modalActions}>
        <ModalHeader closeModal={handleCloseActionsModal} title="Ações" />
        <ModalBody>
          <div className="modal-buttons-group">
            <div className="modal-buttons">
              <RemoveAssistanceContainer
                selectedRows={selectedRows}
                handleCloseActionModal={() => handleCloseActionsModal()}
                isEvent={tab === 'not_executed'}
              />
              {tab === 'not_executed' && <LatestAppointmentsExecuteContainer handleEventStatus={handleEventStatus} />}
            </div>
          </div>
        </ModalBody>
      </ModalPanel>
    </div>
  )
}